import { RouteStopWithHandle } from "@/lib/planRouteParser"

/**
 * "Loaded kilometers" — the distance driven while carrying cargo, i.e. from the
 * first pickup to the last delivery. The route prepends the driver's current
 * position and the legs before the first pickup (driver → pickup) are empty
 * driving, so they're excluded.
 *
 * Each stop carries the OUTGOING leg distance (in meters) to the next stop, so
 * we sum the legs from the first pickup onward. The last stop has no outgoing
 * leg (distance 0), which naturally drops the return/empty tail.
 *
 * Returns kilometers rounded to one decimal, or undefined when there is no
 * pickup or no distance data.
 */
export function computeLoadedKm(
  stops: RouteStopWithHandle[] | undefined,
): number | undefined {
  if (!stops || stops.length === 0) return undefined

  const firstPickupIdx = stops.findIndex((s) => s.action === "pickup")
  if (firstPickupIdx === -1) return undefined

  const meters = stops
    .slice(firstPickupIdx)
    .reduce((acc, s) => acc + (s.distance || 0), 0)

  if (meters <= 0) return undefined
  return Math.round(meters / 100) / 10
}
